import { Pipe, PipeTransform } from '@angular/core';
import { ForceAny } from '../typescript';

@Pipe({
  name: 'valueExist',
  standalone: true,
})
export class CheckValueInArrayPipe implements PipeTransform {
  transform(
    array: ForceAny[],
    value: ForceAny,
    checkAll: boolean = false,
  ): boolean {
    const compareFunction = (item: ForceAny) => item === value;
    if (!Array.isArray(array)) {
      throw new Error('Provided value for the array is not valid');
    }
    return checkAll
      ? array.every(compareFunction.bind(this))
      : array.some(compareFunction.bind(this));
  }
}
